// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations.scss
// module id = 357
// module chunks = 0